export function trackCTA(linkText: string, linkUrl: string): void {
  if (typeof window === 'undefined') return;
  const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
  if (!w.dataLayer) {
    w.dataLayer = [];
  }
  if (localStorage.getItem('trackingConsent') === 'true') {
    w.dataLayer.push({
      event: 'generic',
      event_name: 'cta_button',
      cta_button: {
        position: 'content',
        link_text: linkText,
        link_url: linkUrl,
      },
    });
  }
}
